import React, { useState } from "react";
import Modal from "../../User/components/Modal";
import Grid from "@mui/material/Grid2";
import { TextField, Button, Typography, InputAdornment, CircularProgress } from "@mui/material";
import applogo from "../assets/logo.svg";
import instance, { updatedToken } from "../../Utils/api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useGlobalContext } from "../../context/Context";
import { Link } from "react-router-dom";
import { requestForToken } from "../../firebase";

const HomePage = ({ handleCloseLoginModal, isLoginModalOpen }) => {
  const [mobileNumber, setMobileNumber] = useState();
  const [otp, setOtp] = useState();
  const [otpDisplayer, setOtpDisplayer] = useState(false);
  const [errors, setErrors] = useState({ mobileNumber: "" });
  const { setUserDisplay } = useGlobalContext();
  const [buttondisable, setButtondisable] = useState(true);
  const [loading, setLoading] = useState(false);

  const handleCloseModal = () => {
    setOtpDisplayer(false);
    setOtp("");
    setMobileNumber("");
    handleCloseLoginModal(); // Call the passed function
    setErrors("")
  };

  const handleMobileNumberChange = (e) => {
    let value = e.target.value;
    value = value.replace(/\D/g, "");

    if (value.length <= 10) {
      setMobileNumber(value);
      setErrors({ mobileNumber: "" });
    }
  };

  const fetchOtp = async () => {
    if (mobileNumber?.length !== 10) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        mobileNumber: "Please enter a valid mobile number",
      }));
      return;
    }
    try {
      setLoading(true);
      const response = await instance.get(
        `Customer/sendOtp?mobile=${mobileNumber}`
      );
      if (response.status === 200) {
        toast.success(response?.data?.message);
        setOtpDisplayer(true);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async () => {
    if (otp.length !== 4) {
      toast.error("Please enter a valid 4-digit OTP.");
      return;
    }
    try {
      setLoading(true);
      const FCMToken = await requestForToken();
      const response = await instance.post("Customer/login", {
        mobile: mobileNumber,
        otp: otp,
        web_fcm_token: FCMToken
      });
      if (response.status === 200) {
        toast.success(response?.data?.message);
        setOtpDisplayer(false);
        handleCloseLoginModal();
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("role", "Customer");
        updatedToken(response.data.token);
        setUserDisplay(true);
        setMobileNumber("");
        setOtp("");
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Modal isOpen={isLoginModalOpen} onClose={handleCloseModal}>
        <section className="login">
          <Grid
            container
            spacing={3}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 8 }}>
              <div className="login-image">
                <img src={applogo} alt="applogo" />
              </div>
            </Grid>
            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 8 }}>
              <div className="admin-textfiled">
                <TextField
                  autoComplete="off"
                  placeholder="Enter your mobile number"
                  label="Mobile number"
                  type="text"
                  onChange={handleMobileNumberChange}
                  value={mobileNumber}
                  error={Boolean(errors.mobileNumber)}
                  helperText={errors.mobileNumber}
                  fullWidth
                  disabled={otpDisplayer || loading}
                  required
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Button variant="text" onClick={fetchOtp}>
                          {loading ? (
                            <CircularProgress size={20} sx={{ color: "#E37B00" }} />
                          ) : (
                            "Send OTP"
                          )}
                        </Button>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>

            </Grid>

            {otpDisplayer ? (
              <>
                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 8 }}>
                  <div className="admin-textfiled">
                    <TextField
                      placeholder="Enter OTP"
                      label="OTP"
                      type="text"
                      onChange={(e) => {
                        const otp = e.target.value.replace(/[^0-9]/g, ""); // restricts input to numbers
                        setOtp(otp); // sets OTP state
                        setButtondisable(otp.length !== 4); // enables button only if OTP is 4 digits
                      }}
                      value={otp}
                      fullWidth
                      required
                      disabled={loading}
                    />

                  </div>
                </Grid>
                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 8 }}>
                  <div className="admin-textfiled">
                    <Button
                      onClick={verifyOtp}
                      disabled={buttondisable || loading}
                      sx={{
                        backgroundColor: `${buttondisable ? '#9c9c9c' : '#E37B00'} !important`,
                        color: '#fff !important',
                        border: 'none !important',
                        '&:hover': {
                          backgroundColor: `${!buttondisable ? '#D06900' : '#9c9c9c'} !important`,
                        },
                        '&.Mui-disabled': {
                          backgroundColor: '#9c9c9c !important',
                          color: '#ffffff !important',
                        },
                      }}
                    >
                      {loading ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : "Verify OTP"}
                    </Button>
                  </div>
                </Grid>{" "}
              </>
            ) : null}

            {/* <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 8 }}>
              <div className="copyright-text">
                <Typography variant="h5">
                  <a href="https://api.whatsapp.com/send?phone=9036074200" target="_blank" >
                    Note : Unable to send otp send otp through whatsapp click here
                  </a>
                </Typography>
              </div>
            </Grid> */}

            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 8 }}>
              <div className="copyright-text">
                <Typography variant="h5">
                  Note: Not Receiving OTP?  {"   "}
                  <a
                    href="https://api.whatsapp.com/send?phone=9036074200"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Connect With Us On WhatsApp
                  </a>
                </Typography>
              </div>
              <div className="copyright-text">
                <Typography variant="h5">
                  <Link to='/termsconditions' target="_blank">
                    Terms & Conditions
                  </Link>
                  <span>
                    Copyrights by <strong>Tailors4U</strong>
                  </span>
                </Typography>
              </div>
            </Grid>
          </Grid>
        </section>
      </Modal>
    </React.Fragment>
  );
};

export default HomePage;
